import DefaultPortrait from "slides/layouts/DefaultPortrait.react";
import DefaultLandscape from "slides/layouts/DefaultLandscape.react";

const renderLayout = (isPortrait, layout) => {
    return isPortrait
        ? layout == null || layout.portrait == null
            ? DefaultPortrait
            : layout.portrait
        : layout == null || layout.landscape == null
        ? DefaultLandscape
        : layout.landscape;
};

const ThemeSet = [
    {
        base: "#ffebee",
        primary: "#ef5350",
        primaryVariation: "#b71c1c",
        secondary: "#454545",
    },
    {
        base: "#fce4ec",
        primary: "#ec407a",
        primaryVariation: "#880e4f",
        secondary: "#454545",
    },
    {
        base: "#f3e5f5",
        primary: "#ab47bc",
        primaryVariation: "#9c27b0",
        secondary: "#454545",
    },
    {
        base: "#ede7f6",
        primary: "#9575cd",
        primaryVariation: "#7e57c2",
        secondary: "#454545",
    },
    {
        base: "#e8eaf6",
        primary: "#7986cb",
        primaryVariation: "#5c6bc0",
        secondary: "#454545",
    },
    {
        base: "#e3f2fd",
        primary: "#1e88e5",
        primaryVariation: "#1565c0",
        secondary: "#454545",
    },
    {
        base: "#e0f2f1",
        primary: "#0097a7",
        primaryVariation: "#00838f",
        secondary: "#454545",
    },
    {
        base: "#f1f8e9",
        primary: "#558b2f",
        primaryVariation: "#33691e",
        secondary: "#454545",
    },
    {
        base: "#f9fbe7",
        primary: "#d4e157",
        primaryVariation: "#c0ca33",
        secondary: "#454545",
    },
    {
        base: "#fffde7",
        primary: "#fdd835",
        primaryVariation: "#fbc02d",
        secondary: "#454545",
    },
    {
        base: "#fff3e0",
        primary: "#ffcc80",
        primaryVariation: "#ff9800",
        secondary: "#454545",
    },
    {
        base: "#efebe9",
        primary: "#a1887f",
        primaryVariation: "#5d4037",
        secondary: "#454545",
    },
    {
        base: "#fafafa",
        primary: "#757575",
        primaryVariation: "#424242",
        secondary: "#454545",
    },
    {
        base: "#757575",
        primary: "#fafafa",
        primaryVariation: "#bdbdbd",
        secondary: "#454545",
    },
];

export { ThemeSet, renderLayout };
